const PUBLIC_PATHS = new Set<string>([
  '/',
  '/features',
  '/pricing',
  '/auth',
  // /login と /register は /auth へのリダイレクト先 (旧URLの被リンク互換のため公開扱い)
  '/login',
  '/register',
  '/verify-email',
  '/contact',
  '/help',
  '/terms',
  '/privacy',
  '/complete-profile',
  '/account-not-found',
  '/account-deleted',
  '/reset-password',
]);

// 利用規約・プライバシーポリシーの過去の版（/privacy/versions/<施行日> など）
const PUBLIC_PREFIXES = ['/terms/versions/', '/privacy/versions/'];

export function isPublicInfoPath(pathname: string): boolean {
  return PUBLIC_PATHS.has(pathname) || PUBLIC_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

export function isPublicPath(pathname: string): boolean {
  return isPublicInfoPath(pathname) || pathname.startsWith('/p/');
}
